module.exports = __webpack_public_path__ + "static/media/github-icon-logo-svg-vector.059b5cc3.svg";